import React from 'react';

require('styles/utils/form/Error.styl');

export default props => {
  return props.show ? <div className="ev-field-error">{props.children}</div> : null;
};
